export const selectAppointmentsState = (state) => state.appointments;
